const getTheme = (state) => state.theme.theme;

export { getTheme };
